import { BackgroundCheckStatus, backgroundCheckStatuses } from '@/backend/features/background-check/types';
import { TFunction } from 'i18next';
import { backgroundCheckStatusToIconMap } from './backgroundCheckStatusMaps';

export const isValidBackgroundCheckStatus = (status: string): status is BackgroundCheckStatus => {
    return Object.keys(backgroundCheckStatuses).includes(status);
};

export const getBackgroundCheckIcon = (status?: string) => {
    if (!status) {
        return backgroundCheckStatusToIconMap['unknown'];
    }

    if (!isValidBackgroundCheckStatus(status)) {
        return backgroundCheckStatusToIconMap['statusNotDefined'];
    }

    return backgroundCheckStatusToIconMap[status];
};

export const getBackgroundCheckStatusLabel = ({ status, t }: { status?: string; t: TFunction<'rms'> }) => {
    if (!status) {
        return t('backgroundCheck.statuses.unknown');
    }

    if (!isValidBackgroundCheckStatus(status)) {
        return t('common.statusNotDefined');
    }

    return t(`backgroundCheck.statuses.${status}`);
};
